<form *ngIf="editMode" [formGroup]="invoiceForm">
    <mat-form-field class="mt-2" style="width: 50%" appearance="outline">
        <mat-label>Nr faktury:</mat-label>
        <input matInput formControlName="invoice" name="invoice" type="text"
               placeholder="Nr faktury" #invoiceNumber>
        <mat-hint align="end">
            {{ invoiceNumber.value.length }} / {{ invoiceMaxLength }}
        </mat-hint>
        <mat-error *ngIf="invoice.value.length < invoiceMinLength && !invoice.errors?.['required']">
            Minimalna długość wynosi {{ invoiceMinLength }} znaków.
        </mat-error>
        <mat-error *ngIf="invoice.value.length > invoiceMaxLength">
            Maksymalna długość wynosi {{ invoiceMaxLength }} znaków.
        </mat-error>
    </mat-form-field>
</form>
